import { Link, useNavigate, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import emptyMenu from "../../../assets/images/img/emptyMenu.svg";
import Paginations from "../../../components/paginaton/Paginations";

const Menu = () => {
  const { branchId, parentId, unitId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState("");
  const [products, setProducts] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    unitId: "",
    categoryId: parentId,
    title: "",
    size: 20,
    part: 1,
    enabled: true,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    description: "",
    menuType: 0,
    price: "",
    packagingPrice: 0,
    discount: 0,
    isTaxFree: false,
    inventory: 0,
    duration: 0,
    capacity: 0,
    imgFile: "",
    imgSrc: null,
    enabled: true,
    ordering: "",
    saleUnitId: "",
    categoryId: parentId,
    snappItem: false,
    // baseProductId: 0,
    baseProductId: "",
    branchId: branchId,
  });
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [saleUnitId, setSaleUnitId] = useState("");
  const [isDataReady, setIsDataReady] = useState(false);
  const [parent, setParent] = useState({
    id: 0,
    title: "",
    parentId: 0,
    // saleUnitId: 0,
    saleUnitId: unitId,
  });

  const getBaseInfo = async () => {
    const menuResp = await apiMethod.getMenuCategoryInfo(parentId);
    if (!methods.showApiErrors(menuResp)) return false;
    setPageTitle(menuResp.data.title);
    filterModel.unitId = menuResp.data.saleUnitId;
    setSaleUnitId(menuResp.data.saleUnitId);

    const productResp = await apiMethod.findProductForMenu(
      branchId,
      500,
      1,
      "",
      ""
    );
    if (methods.showApiErrors(productResp)) setProducts(productResp.data);
  };

  const getGridData = async (customEnabled) => {
    const enabled = customEnabled ?? filterModel.enabled;
    const menuResp = await apiMethod.getMenus(
      filterModel.branchId,
      filterModel.unitId,
      filterModel.categoryId,
      filterModel.size,
      filterModel.part,
      filterModel.title,
      enabled
    );
    if (methods.showApiErrors(menuResp)) {
      filterModel.total = menuResp.total;
      setTotalPages(menuResp.total);
      filterModel.parts = methods.calcPageParts(
        menuResp.total,
        filterModel.size
      );
      setFilterModel({ ...filterModel });
      setGridData(menuResp.data);
    }
  };

  const mapParent = (model) => {
    parent.id = model.id;
    parent.title = model.title;
    parent.parentId = model.parentId === null ? 0 : model.parentId;
    parent.saleUnitId = model.saleUnitId;
    setParent({ ...parent });
  };

  const getParentItem = async (id) => {
    const resp = await apiMethod.getMenuCategoryInfo(id);
    if (methods.showApiErrors(resp)) {
      mapParent(resp.data);
    }
    setPageTitle(resp.data.title);
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData(true);
    setLoading(false);
  };

  useEffect(() => {
    if (saleUnitId) {
      setIsDataReady(true);
    }
  }, [saleUnitId]);

  useEffect(() => {
    getBaseInfo();
    if (parentId > 0) getParentItem(parentId);
    const bindData = async () => {
      setLoading(true);
      await getGridData(true);
      setLoading(false);
    };
    if (isDataReady) {
      bindData();
    }
  }, [branchId, parentId, isDataReady]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (methods.isNullOrEmptyString(formModel.baseProductId)) {
      errors.push(".محصول متصل باید مقدار داشته باشد");
    }
    if (methods.isNullOrEmptyString(formModel.saleUnitId)) {
      errors.push(".بخش فروش باید مقدار داشته باشد");
    }
    if (
      methods.isNullOrEmptyString(formModel.price) ||
      parseInt(formModel.price) === 0
    ) {
      errors.push(".قیمت باید مقدار داشته باشد");
    }
    if (
      methods.isNullOrEmptyString(formModel.ordering) ||
      parseInt(formModel.ordering) === 0
    ) {
      errors.push(".ترتیب نمایش باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.description = "";
    formModel.menuType = 0;
    formModel.price = "";
    formModel.packagingPrice = 0;
    formModel.discount = 0;
    formModel.isTaxFree = false;
    formModel.inventory = 0;
    formModel.duration = 0;
    formModel.capacity = 0;
    formModel.imgFile = "";
    formModel.imgSrc = null;
    formModel.ordering = "";
    formModel.saleUnitId = saleUnitId;
    formModel.categoryId = parentId;
    formModel.snappItem = false;
    // formModel.baseProductId = 0;
    formModel.baseProductId = "";
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = "";
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    filterModel.categoryId = parentId;
    filterModel.enabled = "";
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getMenuInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.description = resp.data.description;
    formModel.menuType = resp.data.menuType;
    formModel.price = resp.data.price;
    formModel.packagingPrice = resp.data.packagingPrice;
    formModel.discount = resp.data.discount;
    formModel.isTaxFree = resp.data.isTaxFree;
    formModel.inventory = resp.data.inventory;
    formModel.duration = resp.data.duration;
    formModel.capacity = resp.data.capacity;
    formModel.imgFile = resp.data.imgFile;
    formModel.imgSrc = resp.data.imgSrc;
    formModel.ordering = resp.data.ordering;
    formModel.saleUnitId = resp.data.saleUnitId;
    formModel.categoryId = resp.data.categoryId;
    formModel.snappItem = resp.data.snappItem;
    formModel.baseProductId = resp.data.baseProductId;
    formModel.branchId = resp.data.branchId;
    formModel.createBy = resp.data.createBy;
    formModel.createDate = resp.data.createDate;
    formModel.modifyBy = resp.data.modifyBy;
    formModel.modifyDate = resp.data.modifyDate;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm()) return false;

    const requestData = {
      ...formModel,
      categoryId: parentId,
    };
    setLoading(true);

    try {
      const resp = await apiMethod.createMenu(requestData);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData(true);
      setShowFormModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);

      const attributeValue = formModel[attributeName];
      if (typeof attributeValue === "string") {
        formData.append(attributeName, attributeValue);
      }
      const response = await apiMethod.uploadFile(formData);

      setFormModel((prevData) => ({
        ...prevData,
        [attributeName]: response.data,
      }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      imgSrc: file,
    }));
    setIsImageUploading(true);

    UploadFile(file, "imgSrc")
      .then(() => {
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData(true);
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData("");
    setLoading(false);
  };

  const handleEnabled = async (id) => {
    setLoading(true);
    const resp = await apiMethod.enableMenu(id);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    await getGridData(true);
  };

  const handleActive = async () => {
    setLoading(true);
    await getGridData(true);
    setLoading(false);
  };
  const handleDeActive = async () => {
    setLoading(true);
    await getGridData(false);
    setLoading(false);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div>
              <Link
                to={
                  parentId == 0
                    ? `/sale/${branchId}/${unitId}/menuCategoryManage/0`
                    : `/sale/${branchId}/${unitId}/menuCategoryManage/${
                        parent.parentId > 0 ? parent.parentId : 0
                      }`
                }
                className="d-none d-lg-block text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={
                    parentId == 0
                      ? `/sale/${branchId}/${unitId}/menuCategoryManage/0`
                      : `/sale/${branchId}/${unitId}/menuCategoryManage/${
                          parent.parentId > 0 ? parent.parentId : 0
                        }`
                  }
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                منوهای زیرمجموعه {pageTitle}
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                منوهای زیرمجموعه {pageTitle}
                <a
                  href={`/sale/${branchId}/softwareGuide/#section5`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row">
                  <div className="col-12 col-md-5">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-7 d-flex align-items-center justify-content-end gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="d-flex align-items-center gap-2"
                        style={{ marginTop: "26px" }}
                      >
                        <button
                          className="btn btn-purple"
                          style={{ height: "48px" }}
                          onClick={handleActive}
                        >
                          منو های فعال
                        </button>
                        <button
                          className="btn btn-purple"
                          style={{ height: "48px" }}
                          onClick={handleDeActive}
                        >
                          منو های غیر فعال
                        </button>
                      </div>
                    </div>
                    <div className="createButton">
                      <button
                        type="button"
                        className="btn custome-btn btn-link-purple"
                        // onClick={() => navigate(`/sale/${branchId}/posDevices/banks`)}
                      >
                        دریافت قالب
                      </button>
                      <button
                        type="button"
                        className="btn custome-btn btn-purple mx-1"
                        // onClick={() => navigate(`/sale/${branchId}/posDevices/banks`)}
                      >
                        بارگذاری اکسل
                      </button>
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          منو جدید
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable position-relative">
                {products.length === 0 ? (
                  <div className="my-5">
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(`/baseinfo/${branchId}/product`);
                        }}
                      >
                        افزودن محصول متصل
                      </button>
                    </div>
                  </div>
                ) : (
                  gridData.length === 0 && (
                    <div className="">
                      <div>
                        <img src={emptyMenu} alt="noItem" />
                      </div>
                      <p>هیچ منو تا کنون برای دسته بندی ثبت نشده است.</p>
                    </div>
                  )
                )}
                <div className="row row-cols-1 row-cols-md-3 g-4">
                  {gridData.map((item) => (
                    <div className="col" key={item.id}>
                      <div className="card h-100">
                        <div className="card-body">
                          <div
                            className="branchCardImg mb-3"
                            style={{
                              backgroundImage: `url(${methods.normalImage(
                                item.imgSrc,
                                "menu"
                              )})`,
                            }}
                          ></div>
                          <p className="menutitle">{item.title}</p>
                          <hr className="" />
                          <div className="d-flex align-items-center justify-content-between">
                            <p>بخش:</p>
                            <p>{item.unitTitle}</p>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <p>قیمت:</p>
                            <p>{methods.addNumSeperator(item.price)}</p>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <p>موجودی:</p>
                            <p>{item.capacity} عدد </p>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <p>هزینه بسته بندی:</p>
                            <p>
                              {methods.addNumSeperator(item.packagingPrice)}
                            </p>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <p>وضعیت:</p>
                            <div className="d-flex align-items-center gap-2">
                              <span>
                                {item.enabled === true ? "فعال" : "غیرفعال"}
                              </span>
                              <div
                                className="form-check form-switch"
                                style={{ paddingLeft: "0" }}
                              >
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={item.enabled}
                                  onChange={() => handleEnabled(item.id)}
                                />
                              </div>
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-outline-purple w-100 mb-2"
                            // onClick={() => handleBranchClick(item)}
                          >
                            اتصال به انبار فروش
                          </button>
                          <div className="d-flex align-items-center justify-content-center border p-2 rounded">
                            <span> ثبت اسنپ</span>
                            <input
                              type="checkbox"
                              // checked={serviceData?.isTaxFree}
                              // onChange={() => taxCheckboxChange()}
                              className="pagercheckbox me-2"
                            />
                          </div>
                          <hr className="mb-0" />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mx-2 mb-1">
                          <button
                            type="submit"
                            className="btn custome-btn CardDeleteBtn"
                            onClick={() => selectَItemToDelete(item)}
                          >
                            حذف
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </button>
                          <button
                            type="submit"
                            className="btn custome-btn btn-link-green"
                            onClick={() => editItem(item.id)}
                          >
                            ویرایش
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil-square"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ right: "95%" }} className="pushData">
                  <button
                    type="button"
                    className="btn btn-lg btn-purple rounded-circle position-relative"
                    onClick={() => {
                      openNewForm();
                    }}
                  >
                    <i className="bi bi-file-earmark-plus"></i>
                  </button>
                </div>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async (id) => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeMenu(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData(true);
      setShowDeleteModal(false);
      resetForm();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش محصول</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-3">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({ ...formModel, title: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="menuType"
                    className="form-label required-label"
                  >
                    نوع منو
                  </label>
                  <select
                    id="menuType"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.menuType}
                    onChange={(e) => {
                      formModel.menuType = parseInt(e.target.value);
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>غذای اصلی</option>
                    <option value={1}>سایر انواع</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="product"
                    className="form-label required-label"
                  >
                    محصول متصل
                  </label>
                  <select
                    id="product"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.baseProductId}
                    onChange={(e) => {
                      formModel.baseProductId = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        baseProductId: formModel.baseProductId,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {products.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor="price" className="form-label required-label">
                    قیمت(ریال)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="price"
                    name="price"
                    value={methods.addNumSeperator(formModel.price)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const price = parseInt(inputValue.replace(/,/g, ""));
                      setFormModel({
                        ...formModel,
                        price: isNaN(price) ? "" : price,
                      });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="packagingPrice" className="form-label">
                    هزینه بسته‌بندی(ریال)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="packagingPrice"
                    name="title"
                    value={methods.addNumSeperator(formModel.packagingPrice)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const packagingPrice = parseInt(
                        inputValue.replace(/,/g, "")
                      );
                      setFormModel({
                        ...formModel,
                        packagingPrice: isNaN(packagingPrice)
                          ? ""
                          : packagingPrice,
                      });
                    }}
                  />
                </div>
                {/* <div className="col-md-3">
                  <label htmlFor="discount" className="form-label">
                    تخفیف(درصد)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="discount"
                    name="discount"
                    value={formModel.discount}
                    onChange={(e) => {
                      setFormModel({ ...formModel, discount: e.target.value });
                    }}
                  />
                </div> */}
                <div className="col-md-3">
                  <label htmlFor="duration" className="form-label">
                    زمان آماده‌سازی(دقیقه)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="duration"
                    name="duration"
                    value={formModel.duration}
                    onChange={(e) => {
                      setFormModel({ ...formModel, duration: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="capacity" className="form-label">
                    ظرفیت تولید(عددی)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="capacity"
                    name="capacity"
                    value={formModel.capacity}
                    onChange={(e) => {
                      setFormModel({ ...formModel, capacity: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="ordering"
                    className="form-label required-label"
                  >
                    ترتیب نمایش
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="ordering"
                    name="ordering"
                    value={formModel.ordering}
                    onChange={(e) => {
                      setFormModel({ ...formModel, ordering: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-3" style={{ marginTop: "55px" }}>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formModel.isTaxFree}
                      onChange={(e) => {
                        setFormModel({
                          ...formModel,
                          isTaxFree: e.target.checked,
                        });
                      }}
                      className="pagercheckbox"
                    />
                    <span className="ms-1">معاف از مالیات</span>
                  </label>
                </div>
                <div className="col-md-3" style={{ marginTop: "55px" }}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={formModel.enabled}
                      onChange={(e) =>
                        setFormModel((prevData) => ({
                          ...prevData,
                          enabled: e.target.checked,
                        }))
                      }
                      id="switchCheckChecked"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="switchCheckChecked"
                    >
                      وضعیت
                    </label>
                  </div>
                </div>
                <div className="col-12"></div>
                <div className="col-md-6">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب تصویر
                    <span style={{ fontSize: "14px" }}>
                      {" "}
                      (اندازه استاندارد 600×900 و حداکثر حجم 600kb است.)
                    </span>
                  </label>
                  <div
                    className="uploadfile"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const file = e.dataTransfer.files[0];
                      changeImage(file);
                    }}
                  >
                    {!isImageUploading && (
                      <label htmlFor="imagefileInput">
                        {formModel.imgSrc
                          ? formModel.imgSrc
                          : "تصویر را بکشید اینجا بیاندازید"}
                        <input
                          type="file"
                          id="imagefileInput"
                          style={{ display: "none" }}
                          name="imagefileInput"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => changeImage(e.target.files[0])}
                        />
                      </label>
                    )}
                    {isImageUploading && (
                      <div className="uploadfileloading form-control border-0">
                        <span
                          className="spinner-border spinner-border-sm"
                          aria-hidden="true"
                        ></span>
                        <span role="status"> در حال بارگذاری ... </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              {isImageUploading ? (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                  disabled
                >
                  ثبت وذخیره
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                  onClick={() => {
                    createNewItem();
                  }}
                >
                  ثبت وذخیره
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"محصول"}
        />
      )}
    </>
  );
};

export default Menu;
